"use client";

import { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AllLeadLookingFor = () => {
  const [lookingForList, setLookingForList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [newLookingFor, setNewLookingFor] = useState({
    looking_for: "",
  });

  /* ================= FETCH ================= */
  useEffect(() => {
    fetchLookingFor();
  }, []);

  const fetchLookingFor = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        "https://logicx.premierlam.com/api/get-pixel-lead-looking-for",
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );
      setLookingForList(res.data.data || []);
    } catch {
      toast.error("Failed to fetch lead looking for list");
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= ADD ================= */
  const handleAddLookingFor = async (e) => {
    e.preventDefault();

    try {
      setIsSubmitting(true);

      await axios.post(
        "https://logicx.premierlam.com/api/add-pixel-lead-looking-for",
        newLookingFor,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Added successfully!");
      setIsAddDialogOpen(false);
      setNewLookingFor({ looking_for: "" });
      fetchLookingFor();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to add");
    } finally {
      setIsSubmitting(false);
    }
  };

  /* ================= HELPERS ================= */
  const filteredList = lookingForList.filter((l) =>
    l.looking_for?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="min-h-screen bg-gray-50 p-2">
        <div className="max-w-7xl mx-auto">

          {/* HEADER */}
          <div className="flex justify-between items-start mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-gray-900 mb-1">
                Lead Looking For
              </h1>
              <p className="text-gray-500">Manage lead looking for options</p>
            </div>

            <button
              onClick={() => setIsAddDialogOpen(true)}
              className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
            >
              + Add Looking For
            </button>
          </div>

          {/* TABLE */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="mb-4 px-4 py-2 border rounded-lg w-64"
            />

            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="text-center py-6">Loading...</div>
              ) : (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b text-gray-600">
                      <th className="py-3 px-4 text-left">Looking For</th>
                      <th className="py-3 px-4 text-left">Created At</th>
                      <th className="py-3 px-4 text-left">Added By</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredList.map((l) => (
                      <tr key={l.id} className="border-b hover:bg-gray-50">
                        <td className="py-3 px-4">{l.looking_for}</td>
                        <td className="py-3 px-4 whitespace-nowrap">
                          {formatDate(l.created_at)}
                        </td>
                        <td className="py-3 px-4">{l.added_by}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          {/* ADD MODAL */}
          {isAddDialogOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
              <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
                <button
                  className="absolute top-2 right-2 text-gray-400"
                  onClick={() => setIsAddDialogOpen(false)}
                >
                  ✖
                </button>

                <h2 className="text-lg font-semibold mb-4">
                  Add Lead Looking For
                </h2>

                <form onSubmit={handleAddLookingFor} className="space-y-3">
                  <input
                    type="text"
                    placeholder="Looking For"
                    value={newLookingFor.looking_for}
                    onChange={(e) =>
                      setNewLookingFor({ looking_for: e.target.value })
                    }
                    className="w-full border rounded px-3 py-2"
                    required
                  />

                  <div className="flex justify-end gap-3 pt-3">
                    <button
                      type="button"
                      onClick={() => setIsAddDialogOpen(false)}
                      className="px-4 py-2 bg-gray-100 rounded"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="px-4 py-2 bg-orange-500 text-white rounded"
                    >
                      {isSubmitting ? "Adding..." : "Add"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

        </div>
      </div>
    </>
  );
};

export default AllLeadLookingFor;
